import * as React from 'react';
import { ArticleHeading2, InlineText1 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { DETAILED_SPECIFICATIONS_ICON_MAP } from '../../../../constants/detailedSpecifications';
import { IDetailedSpecification } from '../../../../types/newbuilding/specificationsDetailed';

interface IDetailedSpecificationsProps {
  title: string;
  items: IDetailedSpecification[];
}

export function DetailedSpecifications({ title, items }: IDetailedSpecificationsProps) {
  return (
    <div className={styles['container']}>
      <ArticleHeading2 as="h2">{title}</ArticleHeading2>
      <div className={styles['items-container']}>
        {items.map(({ type, title }) => (
          <div key={type} className={styles['item']}>
            {DETAILED_SPECIFICATIONS_ICON_MAP[type]}
            <div className={styles['title']}>
              <InlineText1>{title}</InlineText1>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
